export enum QAErrorMessages {
  NoAssessmentIDFound = 'No assessment ID found',
  TaskError = 'An error occurred while fetching the task data',
  CommentsError = 'An error occurred while fetching comments',
  AssessmentError = 'An error occurred while fetching QuestionnaireResponse data'
}

export enum BlockedAccessMessages {
  NoQaTask = 'This assessment is not currently in QA',
  NoAccess = "You don't have access to this assessment"
}

export const MAX_QA_ROUNDS = 5

export enum Review485TaskAssigneeOptions {
  SELF = 'SELF',
  ORIGINAL_AUTHOR = 'ORIGINAL_AUTHOR',
  CLINICAL = 'CLINICAL'
}
